module.exports = __webpack_public_path__ + "img/brown.0ce02ead.svg";